<template>
	<div>
		<div class="tabs">
			<ul>
				<li v-for="tab in tabs" :class="[tab.isActive ? 'is-active' : 'no-active']" :key="tab.href">
					<a :href="tab.href" @click="selectTab(tab)">{{ tab.name }}</a>
				</li>
			</ul>
		</div>

		<div class="tabs-details">
			<slot></slot>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return { tabs: [] }
	},

	created() {
		this.tabs = this.$children
	},
	methods: {
		selectTab(selectedTab) {
			this.tabs.forEach((tab) => {
				tab.isActive = tab.name == selectedTab.name
			})
		},
	},
}
</script>
<style lang="scss" scoped>
ul {
	padding: 0px;
	margin: 0px;
}
.tabs ul li {
	display: inline-block;
	font-size: 1em;
	margin: 15px 10px;
	font-size: 1em;
	width: 40%;
	border-radius: 5px;
	text-transform: capitalize;
	padding: 0.2em;
}

.tabs {
	width: 100%;
	text-align: center;
	position: sticky;
	top: -1px;
	background: white;
	z-index: 1;
	overflow: auto;
	white-space: nowrap;
}

.is-active a {
	color: white;
}
a {
	color: rgba(0, 0, 0, 0.54);
}
.is-active {
	// border-bottom: 1px solid #f2c94c;
	background: #0045e7 !important;
}

.no-active {
	background: #f7f7f7;
	border: 1px solid #e5e5e5;
}
.tabs-details {
	// margin: 0px auto !important;
	// justify-content: center;
	// display: flex;
}

a {
	text-decoration: none;
	line-height: 2em;
	// text-transform: uppercase;
}

.input-container {
	padding-bottom: 0.5em;
}
.left-inner-addon {
	position: relative;
}
.left-inner-addon input {
	padding-left: 35px !important;
}
.left-inner-addon i {
	position: absolute;
	padding: 12px 12px;
	pointer-events: none;
	color: #757070;
}
input {
	width: 100%;
	padding: 1em !important;
	margin: 0em !important;
	box-sizing: border-box;
	border-radius: 4px;
	border: 1px solid #e0e0e0;
}
input::-webkit-input-placeholder {
	color: rgba(117, 112, 112, 1);
	font-size: 1.2em;
}

.tutorial {
	background: white;
	width: 100vw;
	height: 76px;
	display: flex;
	justify-content: center;
	align-items: center;
	position: sticky;
	bottom: 0;
	button {
		background: #feca38;
		border: 1px solid #feca38;
		box-sizing: border-box;
		border-radius: 6px;
		padding: 0.8em;
		width: 90%;
		font-size: 18px;
	}
}

.mostratMas {
	color: #feca38;
	text-align: center;
	border: 1px solid #feca38;
	box-sizing: border-box;
	border-radius: 6px;
	padding: 0.8em;
	width: 90%;
	margin: 1em;
	background: white;
}
</style>
